<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <footer id="footer">
        <div class="background">
            <img src="@/assets/photos/landscape-blur-3200.jpg" srcset="@/assets/photos/landscape-blur-3200.jpg 3200w,
                @/assets/photos/landscape-blur-2400.jpg 2400w,
                @/assets/photos/landscape-blur-1600.jpg 1600w,
                @/assets/photos/landscape-blur-1200.jpg 1200w,
                @/assets/photos/landscape-blur-800.jpg 800w" />
        </div>
        <div class="content">
            <div class="center">
                <div class="links">
                    <div class="logo">
                        <a href="/#hero" title="OnlyOneProd" @click="clickHandler">
                            <img src="@/assets/onlyoneprod-logo-white.svg" alt="Only One Prod" class="logo" />
                        </a>
                    </div>
                    <nav class="menu">
                        <ul>
                            <li><a href="/#services" target="_self" title="Découvrez nos services"
                                    @click="clickHandler">Nos services</a></li>
                            <li><a href="/#valeurs" target="_self" title="Découvrez nos valeurs"
                                    @click="clickHandler">Nos valeurs</a></li>
                            <li><a href="/#methodology" target="_self" title="Découvrez notre méthode"
                                    @click="clickHandler">Notre méthode</a></li>
                            <li><a href="/#partners" target="_self" title="Découvrez nos partenaires"
                                    @click="clickHandler">Ils nous font confiance</a></li>
                            <li><a href="/#contact" target="_self" title="Contactez nous" @click="clickHandler">Nous
                                    contacter</a></li>
                            <li><a href="/mentions-legales" target="_self" title="Mentions légales du site">Mentions
                                    légales</a></li>
                        </ul>
                    </nav>
                    <div class="social">
                        <ul>
                            <li><a href="https://www.instagram.com/onlyoneprod/" target="_blank"><img src="@/assets/icons/icon-ig.svg" alt="Instagram" /></a></li>
                            <li><a href="https://www.facebook.com/onlyoneprod" target="_blank"><img src="@/assets/icons/icon-fb.svg" alt="Facebook" /></a></li>
                        </ul>
                    </div>
                </div>
                <div class="copyright">
                    <p>Tous droits réservés - OnlyOneProd - 2025</p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";

import { defineProps } from "vue";

const props = defineProps<{
    isHome?: boolean;
}>();

const clickHandler = (event: Event) => {
    if (props.isHome) {
        event.preventDefault();
        event.stopPropagation();

        let target = event.target as HTMLElement;
        if(target && target.tagName !== "A") {
            target = target.parentElement as HTMLElement;
        }

        const targetName = (target as HTMLAnchorElement).href.split("#")[1];
        trackButtonClick(`home-footer-${targetName}`);
        scrollToSection(targetName);
    }
};
</script>

<style lang="sass">
</style>